import { TooltipContext } from "./chunk-RZRE54IY.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Tooltip/Tooltip.Trigger.tsx
import React, { useContext, forwardRef } from "react";
import clsx from "clsx";
var DEFAULT_COMPONENT = "button";
var TooltipTrigger = forwardRef((_a, ref) => {
  var _b = _a,
    {
      className,
      children,
      as
    } = _b,
    rest = __objRest(_b, ["className", "children", "as"]);
  const Component = as || DEFAULT_COMPONENT;
  const {
    id
  } = useContext(TooltipContext);
  return /* @__PURE__ */React.createElement(Component, __spreadProps(__spreadValues({
    ref
  }, rest), {
    type: Component === DEFAULT_COMPONENT ? "button" : void 0,
    className: clsx("pd-tooltip__trigger", className),
    "aria-describedby": "tooltip-".concat(id)
  }), children);
});
var Tooltip_Trigger_default = TooltipTrigger;
export { Tooltip_Trigger_default };